import { Injectable, inject } from '@angular/core';
import { OffcanvasComponent, OffcanvasService } from '@coreui/angular';
import { BizEntityFunctionTypes, BizEntityTypeCategory, IBizEntityType } from '@optima-stride-ai/core';
import { OffCanvasPlacement } from '@optima-stride-ai/optima-components';


// export enum OffCanvasPlacement{
//   Start = "start",
//   End = "end",
//   Top = "top",
//   Bottom = "bottom"
// }

export enum FormStates {
  Idle,
  New,
  Edit,
  View
}

// export enum OffCanvasIDsInDefaultLayout {
//   l1_id = "off-canvas-in-default-layout", // CAUTION: See function getOffCanvasIdFromLevel below. If you change this value, change there as well.
//   l2_id = "off-canvas-in-default-layout-l-2",  // CAUTION: See function getOffCanvasIdFromLevel below. If you change this value, change there as well.
//   l3_id = "off-canvas-in-default-layout-l-3",  // CAUTION: See function getOffCanvasIdFromLevel below. If you change this value, change there as well.
//    // CAUTION: See function getOffCanvasIdFromLevel below. If you add any value here, add there as well.
//   l1_bottom_id = "off-canvas-bottom-layout",
//   l2_bottom_id = "off-canvas-bottom-layout-l-2",
//   l3_bottom_id = "off-canvas-bottom-layout-l-3",
// }

// export function getOffCanvasIdFromLevel(l: number, placement: OffCanvasPlacement = OffCanvasPlacement.End) {

//   switch(placement){
//     case OffCanvasPlacement.End:
//       switch(l){
//         // TBD - refactoring change name of enum item to ln_end_id
//         case 1:
//           return OffCanvasIDsInDefaultLayout.l1_id;
//         case 2:
//           return OffCanvasIDsInDefaultLayout.l2_id;
//         case 3:
//           return OffCanvasIDsInDefaultLayout.l3_id;
//         default:
//           return OffCanvasIDsInDefaultLayout.l1_id;
//       }
//     case OffCanvasPlacement.Bottom:
//       switch(l){
//         case 1:
//           return OffCanvasIDsInDefaultLayout.l1_bottom_id;
//         case 2:
//           return OffCanvasIDsInDefaultLayout.l2_bottom_id;
//         case 3:
//           return OffCanvasIDsInDefaultLayout.l3_bottom_id;
//         default:
//           return OffCanvasIDsInDefaultLayout.l1_bottom_id;
//       }
//     default:
//       switch(l){
//         // TBD - refactoring change name of enum item to ln_end_id
//         case 1:
//           return OffCanvasIDsInDefaultLayout.l1_id;
//         case 2:
//           return OffCanvasIDsInDefaultLayout.l2_id;
//         case 3:
//           return OffCanvasIDsInDefaultLayout.l3_id;
//         default:
//           return OffCanvasIDsInDefaultLayout.l1_id;
//       }  
//   }

//   // switch(l){
//   //   case 1:
//   //     return OffCanvasIDsInDefaultLayout.l1_id;
//   //   case 2:
//   //     return OffCanvasIDsInDefaultLayout.l2_id;
//   //   case 3:
//   //     return OffCanvasIDsInDefaultLayout.l3_id;
//   //   default:
//   //     return OffCanvasIDsInDefaultLayout.l1_id;
//   // }
// }

export enum OffCanvasComponents {
  //Use these instead of using plan elements directly. This is to make it easier to add non-plan element off-canvas forms.
  //We need to make a connection between PlanElement and OffCanvasComponent, so for selected planElement, one of the appropriate off-canvas component can be opened.
  //See Important note below
  Org,
  Company,
  Vision,
  AddDashboard,
  // OKR, //Objectives, Key Results Update: Removed to avoid confusion
  Objective, //Objective could represent OKR, so be mindful when using this value. Introduced later because instead of OKR we are calling em objectives.
  BizEntity,
  Goal,
  Department,
  Measure,
  // txnLog,
  KPI,
  User,
  Deliverable,
  Chat,
  Task,
  ViewFilter,
  Team,
  Role,
  Risk,
  Plan,
  Challenge,
  Project,
  FocusArea,
  BizEntityType,
  SoftwareEngineeringProductivity,
  Notifications,
  None,

  // TBD - To be moved to new Detail Views
  DeliverableDetail,
  KPIDetail,
  MeasureDetail,
  CheckinDetail,
  StructureDetail,
  TxnLogDetail,
  ObjectiveDetail,
  RelationshipConfiguration,
  TxnLog,
  AddLibraryFolder,
  UpdateLibraryFolder,
  AddFolder,
  AddFile,
  SaveAsTemplate,
}
export enum OffCanvasRightContentTypes{
  BizEntityForms,
  Others,
  None,
  DetailForm
}

export interface iOffCanvasState {
  containerID: string;
  level: number;
  componentInOffCanvas: OffCanvasComponents;
  componentIsABizEntity?: boolean
  onClose?: () => void | undefined; //callback to be called when off-canvas is closed from top button.
}

@Injectable({
  providedIn: 'root'
})

export class OffCanvasFormService {
  private offCanvasServiceRef = inject(OffcanvasService);
  private _bypassPlanElementsCheck: boolean = false;
  private offCanvasPlanFormComponentRef?: OffcanvasComponent;
  private _dataOfTheCurrentFormInView: any;
  private _offCanvasState: iOffCanvasState[] = [];
  private _offCanvasStateInWaiting: iOffCanvasState[] = [];

  get bypassPlanElementsCheck(): boolean {
    return this._bypassPlanElementsCheck
  }

  private _currentHighestLevel: number = 0;

  private pushState(state: iOffCanvasState) {
    //===== CAUTION ======
    // pushState takes precedence over selectedPlanElement, so take care of that.
    // Eventually we have to get rid of selectedPlanElement and use pushState only.
    this._bypassPlanElementsCheck = true; //assuming and trusting pushState is called when logic is flowing with the help of OffCanvasComponents in state instead of selectedPlanElement.
    this._offCanvasState.push(state);
    this._currentHighestLevel = Math.max(this._currentHighestLevel, state.level);
     }

  private popState(): iOffCanvasState {
    const popped = this._offCanvasState.pop();
    if (this._offCanvasState.length == 0) {
      this._bypassPlanElementsCheck = false;
      this._currentHighestLevel = 0;
    } else {
      this._currentHighestLevel = this._offCanvasState.map(x => x.level).reduce((a, b) => Math.max(a, b));
    }
    return popped!;
  }

  get currentOffCanvas() {
    return this._offCanvasState[this._offCanvasState.length - 1];
  }

  get currentHighestLevel() {
    return this._currentHighestLevel;
  }

  getLastOffCanvasAtLevel(level: number): iOffCanvasState | undefined {
    // user array.prototype.findLast() instead of this method. Not available in this version change compiler option to es2023. Maybe do later
    for (let i = this._offCanvasState.length - 1; i >= 0; i--) {
      if (this._offCanvasState[i].level == level) {
        return this._offCanvasState[i];
      }
    }
    return undefined;
  }


  constructor() { }

  public set planFormComponentRef(v: OffcanvasComponent) {
    this.offCanvasPlanFormComponentRef = v;
  }
  public get planFormComponentRef(): OffcanvasComponent | undefined {
    return this.offCanvasPlanFormComponentRef;
  }

  public get dataOfCurrentFormInView(): any {
    return this._dataOfTheCurrentFormInView
  }

  public set dataOfCurrentFormInView(data: any) {
    this._dataOfTheCurrentFormInView = data
  }


  popstateInProgress: boolean = false;
  //Note: Should be renamed to popState. We are popping state from offCanvas service and stack is not required as Push/Pop are stack actions.
  public stackPop(state: iOffCanvasState | undefined) {
    if (state) {
         while (this.popstateInProgress) { } //wait for the previous popstate to finish
      if (this._offCanvasState[this._offCanvasState.length - 1]?.componentInOffCanvas == state.componentInOffCanvas) {
        this.popstateInProgress = true;
        //Note: See impact of following timeout and remove if required.
        setTimeout(() => {
          const popped = this.popState();
                 if(popped.level !== this._offCanvasState.length + 1){
            throw new Error("OffCanvasService: State mismatch. Either some state is missing or Some form states are still lingering in the stack.");
          }
          this.popstateInProgress = false
        }, 1)
      } else {
        throw new Error("OffCanvasService: State mismatch. Cannot close off-canvas form.")
      }
    }
  }

  private stateInWaiting: iOffCanvasState | undefined
  public stackPush(state: iOffCanvasState) {
    this._bypassPlanElementsCheck = true;
    this.pushState(state)
  }

}

/**
 * @deprecated //Should be moved to a more appropriate place
 */
export function getOffCanvasComponentForBizEntityCategory(forType:IBizEntityType | undefined): OffCanvasComponents | null {
    if (!forType) return null;
    switch (forType.category) {
      case BizEntityTypeCategory.Tenant:
        return OffCanvasComponents.Org;
      case BizEntityTypeCategory.BenzaitenChallenge:
        return OffCanvasComponents.Challenge;
      case BizEntityTypeCategory.BenzaitenProject:
        return OffCanvasComponents.Project;
      case BizEntityTypeCategory.UserDefined:
        if(forType.functionType === BizEntityFunctionTypes.Structural) {
          return OffCanvasComponents.BizEntity;
        } else { //BizEntityFunctionTypes.Operational
          return OffCanvasComponents.Deliverable; //For now, always returns Deliverable but Operational could be other too - Object/Deliverable/Task (maybe not kpi and/or measure)
        }
      case BizEntityTypeCategory.BenzaitenObjective:
        return OffCanvasComponents.Objective;
      case BizEntityTypeCategory.BenzaitenDeliverable:
        return OffCanvasComponents.Deliverable;
      case BizEntityTypeCategory.BenzaitenMeasure:
        return OffCanvasComponents.Measure;
      case BizEntityTypeCategory.BenzaitenKPI:
        return OffCanvasComponents.KPI;
      case BizEntityTypeCategory.BenzaitenTask:
        return OffCanvasComponents.Task;
      case BizEntityTypeCategory.User:
        return OffCanvasComponents.User;
      case BizEntityTypeCategory.Team:
        return OffCanvasComponents.Team;      
      default:
        return OffCanvasComponents.BizEntity;
    }
  }

export function getDetailComponentBasedOnType(type:IBizEntityType)
{
  switch(type.category)
  {
    case BizEntityTypeCategory.BenzaitenDeliverable:
      return OffCanvasComponents.DeliverableDetail;
    case BizEntityTypeCategory.BenzaitenMeasure:
      return OffCanvasComponents.MeasureDetail;
    case BizEntityTypeCategory.BenzaitenKPI:
      return OffCanvasComponents.KPIDetail;
    case BizEntityTypeCategory.Structural:
      return OffCanvasComponents.StructureDetail;  
    case BizEntityTypeCategory.Transactional:
      return OffCanvasComponents.TxnLogDetail;
    case BizEntityTypeCategory.BenzaitenObjective:
      return OffCanvasComponents.ObjectiveDetail;  
    default:
      return OffCanvasComponents.None;  
  }
}